import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();

  console.error(error);

  return (
    <div className="error-page">
      <h1>Opps! Somenthing went wrong</h1>
      <p>{error?.message}</p>
    </div>
  );
}